import { reportClientError } from "#ce/utils/error-report";
import { detectCurrentWebsiteWithFallback } from "./publishing-domain";

/** Prepares each inert finder page for its website, then inserts its ordinary HTML. Reports preparation errors and still inserts the affected page. */
export function prepareFinderWebsitePages(root = document) {
  for (const template of root.querySelectorAll("template[data-finder-website-page]")) {
    const content = template.content;
    const script = content.querySelector("script[data-finder-website-payload]");

    try {
      const payload = JSON.parse(script.textContent);
      const website = detectCurrentWebsiteWithFallback(payload.fallbackWebsite);

      for (const filter of content.querySelectorAll("sp-finder-filter[data-filter-name]")) {
        const options = payload.filters[filter.getAttribute("data-filter-name")];

        if (!options) {
          continue;
        }

        const selected = options.websites[website] ?? options.default;

        if (!selected.render) {
          filter.remove();
          continue;
        }

        for (const [name, value] of Object.entries(selected.attributes)) {
          if (value != null && !filter.hasAttribute(name)) {
            filter.setAttribute(name, value === true ? "" : String(value));
          }
        }
      }
    } catch (error) {
      reportClientError("Finder website payload preparation failed", {
        description: error.message,
        baseUrl: import.meta.url,
        omitPage: true,
      });
    } finally {
      script?.remove();
      template.replaceWith(content);
    }
  }
}

/** Prepares initial and remotely inserted finder pages before their custom elements boot. Returns a listener disposer. */
export function installFinderWebsitePayloads() {
  prepareFinderWebsitePages();
  document.addEventListener("sparkle:content-did-update", prepareUpdatedContent, true);

  return dispose;

  function prepareUpdatedContent(event) {
    prepareFinderWebsitePages(event.target);
  }

  function dispose() {
    document.removeEventListener("sparkle:content-did-update", prepareUpdatedContent, true);
  }
}
